import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button/Button';
import classes from './DroppedCallModal.module.scss';

const DroppedCallModal = (props) => {
  const { clearCall, redialCall, isOnline, callDialString } = props;
  const buttonStyle = { width: 200, minWidth: 200, height: 50 };
  return (
    <div className={classes.droppedCallContainer}>
      <h2 className={classes.droppedCallTitle}>
        <FormattedMessage id="components.droppedCall.title" defaultMessage="Unable to Reconnect" />
      </h2>
      <div className={classes.droppedCallText}>
        {callDialString ? (
          <FormattedMessage
            id="components.droppedCall.body"
            defaultMessage="We were unable to recover your network connection and had to drop the call. Please try to call in again."
          />
        ) : (
          <FormattedMessage
            id="components.droppedCall.bodyNoRedial"
            defaultMessage="We were unable to recover your network connection and had to drop the call."
          />
        )}
      </div>
      <div className={classes.buttonBar}>
        <Button kind={callDialString ? 'secondary' : 'primary'} onClick={clearCall} style={buttonStyle}>
          <FormattedMessage id="components.droppedCallModal.close" defaultMessage="Close" />
        </Button>
        {callDialString && (
          <Button kind={'primary'} onClick={redialCall} style={buttonStyle} disabled={!isOnline}>
            <FormattedMessage id="components.droppedCallModal.redial" defaultMessage="Redial" />
          </Button>
        )}
      </div>
    </div>
  );
};

DroppedCallModal.propTypes = {
  clearCall: PT.func,
  redialCall: PT.func,
  isOnline: PT.bool,
  callDialString: PT.string
};

export default DroppedCallModal;
